import type { ErrorMessage } from '@repo/types/messages/error';

import { ErrorCodes } from '#errorCodes';

export const defaultErrorMessage: ErrorMessage = {
  title: 'Wystąpił błąd',
  detail: 'Coś poszło nie tak',
  status: 500,
  code: ErrorCodes.GENERIC.INTERNAL_SERVER_ERROR_500,
  severity: 'error',
};
